<template>
  <footer class="app-footer">
    <span>Lighthouse &copy; 2025 </span>
    <span>
      <router-link class="ml-2" :to="{ path: '/tos' }">
          End User Agreement
        </router-link>
      </span>
    <span class="ml-auto">Built by <a href="http://alliesagainstslavery.org">Allies Against Slavery</a></span>
  </footer>
</template>
<script>
export default {
  name: 'c-footer'
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue